import axios from 'axios';
import { API_URL } from '../../config/api';
export interface Circle {
  id: number;
  name: string;
  description: string | null;
  avatar_url: string | null;
  member_count: number;
  owner_id: number;
  owner_name: string;
  created_at: string;
}
export interface Member {
  id: number;
  email: string;
  username: string;
  full_name: string | null;
  avatar_url: string | null;
  is_verified: boolean;
  role: string;
  joined_at: string | null;
}
export interface CircleDetails {
  id: number;
  name: string;
  description: string | null;
  owner_id: number;
  created_at: string;
  members: Member[];
  member_count: number;
}
export interface Filters {
  size: string;
  from: string;
  to: string;
}
export const emptyFilters: Filters = {
  size: '',
  from: '',
  to: ''
};
export const sizeLabel = (count: number) => count <= 2 ? 'Small' : count <= 5 ? 'Medium' : 'Large';
export const sizeText = (count: number) => ({ Small: 'Küçük', Medium: 'Orta', Large: 'Büyük' })[sizeLabel(count)];
export const roleLabel = (role: string) => role === 'owner' ? 'Sahip' : role === 'admin' ? 'Yönetici' : role === 'member' ? 'Üye' : role;
export async function fetchCircles() {
  const all = new Map<number, Circle>();
  const limit = 1000;
  const maxPages = 100;
  for (let page = 0; page < maxPages; page += 1) {
    const response = await axios.get<Circle[]>(`${API_URL}/admin/families`, {
      params: {
        skip: page * limit,
        limit
      }
    });
    if (!Array.isArray(response.data)) throw new Error('Invalid circle list');
    response.data.forEach(circle => all.set(circle.id, circle));
    if (response.data.length < limit) return {
      circles: Array.from(all.values()),
      partial: false
    };
  }
  return {
    circles: Array.from(all.values()),
    partial: true
  };
}
